<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :toPdf="toPdf" :excelShow="true" :toExe="handToExe" :excelDisabled="loading || excelDisabled"></MulReportHeader>
        <Collapse v-show="table.data.length > 0" :value="panelName">
            <Panel v-for="(item, index) in getShowPannelData()" :key="index" :name="`${item.platid}`">
                {{ item.platname }}
                <div slot="content">
                    <Table border :columns="getColumn(temp)" :data="temp.data" style="margin-top: 12px" v-for="(temp, count) in getShowTableData(item.data)" :key="count"></Table>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
import moment from 'moment'
import { gameSortMap } from '@/libs/config'
export default {
    name: 'HandicapGameData',
    components: { MulReportHeader },
    data() {
        return {
            loading: false,
            excelDisabled: false,
            searchTime: 0,
            TransTopReqTimer: null,
            timestamp: 0,
            tempData: [],
            panelName: [],
            tableTime: '',
            gameSortMap,
            table: {
                params: {
                    platids: [],
                    app_ids: [],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                yData: {}
            }
        }
    },
    methods: {
        getShowTableData(data) {
            let from = this.copyData(data || [])
            let result = []
            from.forEach((val, index) => {
                let i = Math.floor(index / 2)
                if (!result[i]) {
                    result[i] = val
                } else {
                    result[i].app_name1 = val.app_name
                    result[i].platname1 = val.platname
                    for (let k = 0; k < val.data.length; k++) {
                        let item = val.data[k]
                        let find = result[i].data.find((el) => el.game_id == item.game_id)
                        if (find) {
                            if (item.cellClassName) {
                                find.cellClassName = Object.assign(find.cellClassName || {}, {
                                    loss_rate_offset1: item.cellClassName.loss_rate_offset
                                })
                            }
                            find.nextType = item
                        } else {
                            let obj = {
                                game_id: item.game_id,
                                game_name: item.game_name,
                                nextType: item
                            }
                            if (item.cellClassName) {
                                Object.assign(obj, {
                                    cellClassName: {
                                        loss_rate_offset1: item.cellClassName.loss_rate_offset
                                    }
                                })
                            }
                            result[i].data.push(obj)
                            result[i].data.sort((a, b) => (this.gameSortMap[a.game_id] > this.gameSortMap[b.game_id] ? 1 : -1))
                            let index = result[i].data.findIndex((el) => el.game_id == -10)
                            if (index != -1) {
                                let a = result[i].data.splice(index, 1)
                                result[i].data.push(...a)
                            }
                        }
                    }
                }
            })
            return result
        },
        getShowPannelData() {
            let arr = []
            let arrayMap = {}
            this.table.data.forEach((item) => {
                let find = arrayMap[item.platid]
                if (find != null) {
                    arr[find].data.push(item)
                } else {
                    arrayMap[item.platid] = arr.length
                    arr.push({
                        platid: item.platid,
                        platname: item.platname,
                        data: [item]
                    })
                }
            })
            return arr
        },
        toPdf() {
            if (this.table.data.length == 0) {
                return this.$Message.error('暂无数据')
            }
            let arr = this.getShowPannelData()
            this.panelName = arr.map((el) => `${el.platid}`)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        //查询数据
        searchData(emitProps) {
            let paramsList = this.getAllHttpAppid(this.table.params)
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            //获取此次请求时间
            let timestamp = new Date().getTime()
            let httpList = []
            let callList = []
            for (let i = 0, len = paramsList.length; i < len; i++) {
                let app_id = paramsList[i]
                let app_name = ''
                let platid = 0
                let platname = ''
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                if (item) {
                    app_name = item.appName
                    platid = item.platform
                    platname = emitProps.plat_list.find((el) => el.id == platid).name
                }
                let params = this.getTransTopParams('GetNewGameLossInfo2', { platid, app_id, app_name, timestamp, stime, etime, general: -1, pack_no: -1, platname })
                let params1 = this.copyData(params)
                params1.param._param.stime -= 24 * 60 * 60
                params1.param._param.etime -= 24 * 60 * 60
                callList.push(1)
                httpList.push([params1, params])
            }
            this.searchTime = stime
            this.timestamp = timestamp
            this.table.yData = {}
            this.table.data = []
            this.excelDisabled = true
            this.tempData = []
            this.panelName = []
            this.openTimer()
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, callList)
            }
            this.tableTime = moment(this.table.params.dataTime).format('YYYY/MM/DD')
        },
        async toHttp(http_array, loading_array) {
            if (http_array.length > 0) {
                let pList = http_array.shift()
                let [params, params1] = pList
                if (params.timestamp == this.timestamp) {
                    this.openTimer()
                    TransTopReq(params)
                        .then((res) => {
                            if (params.timestamp == this.timestamp) {
                                let data = res._param.data || []
                                let params4 = this.copyData(params)
                                params4.param._func = 'GetNewPlatfromData'
                                TransTopReq(params4)
                                    .then((res1) => {
                                        if (this.timestamp == params.timestamp) {
                                            let bet_point = 0
                                            let loss_point = 0
                                            let map = (data || []).reduce((result, item) => {
                                                bet_point += item.bet_point
                                                loss_point += item.loss_point || 0
                                                result[item.game_id] = item
                                                return result
                                            }, {})
                                            let all = this.getAllData(bet_point, loss_point, params.app_id)
                                            all.sub_user_num = res1._param.bet_user_num || 0
                                            map[-10] = all
                                            this.$set(this.table.yData, params.app_id, map)
                                            this.table.yData[params.app_id] = map
                                            TransTopReq(params1)
                                                .then((res) => {
                                                    if (this.timestamp == params.timestamp) {
                                                        let data = res._param.data || []
                                                        let bet_point = 0
                                                        let loss_point = 0
                                                        data.sort((a, b) => (this.gameSortMap[a.game_id] > this.gameSortMap[b.game_id] ? 1 : -1))
                                                        data.forEach((item) => {
                                                            item.platid = params.platid
                                                            item.app_id = params.app_id
                                                            bet_point += item.bet_point
                                                            loss_point += item.loss_point
                                                        })
                                                        let all = this.getAllData(bet_point, loss_point, params1.app_id)
                                                        let params3 = this.copyData(params1)
                                                        let matchArray = ['sub_user_num', 'bet_point', 'loss_rate']
                                                        params3.param._func = 'GetNewPlatfromData'
                                                        TransTopReq(params3)
                                                            .then((res1) => {
                                                                if (params.timestamp == this.timestamp) {
                                                                    if (data.length > 0) {
                                                                        all.sub_user_num = res1._param.bet_user_num || 0
                                                                        let result = [...data, all]
                                                                        result.forEach((val) => {
                                                                            let mapItem = {}
                                                                            for (let key in val) {
                                                                                if (matchArray.includes(key)) {
                                                                                    let keyOffset = key + '_offset'
                                                                                    let item = this.getOffsetAndColor(val, key)
                                                                                    mapItem[keyOffset] = item
                                                                                    if (key == 'loss_rate') {
                                                                                        if (mapItem[keyOffset] > 0.06) {
                                                                                            mapItem.cellClassName = { loss_rate_offset: 'is-green' }
                                                                                        } else if (mapItem[keyOffset] < 0) {
                                                                                            mapItem.cellClassName = { loss_rate_offset: 'is-red' }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                            Object.assign(val, mapItem)
                                                                        })
                                                                        this.tempData.push({
                                                                            data: result,
                                                                            app_name: params.app_name,
                                                                            app_id: params.app_id,
                                                                            platid: params.platid,
                                                                            platname: params.platname
                                                                        })
                                                                        if (!this.panelName.includes(`${params.platid}`)) {
                                                                            this.panelName.push(`${params.platid}`)
                                                                        }
                                                                    }
                                                                    loading_array.shift()
                                                                    if (loading_array.length == 0) {
                                                                        this.closeTimer()
                                                                        this.excelDisabled = false
                                                                        this.table.data = [...this.tempData]
                                                                    }
                                                                    if (http_array.length > 0) this.toHttp(http_array, loading_array)
                                                                }
                                                            })
                                                            .catch((err) => {
                                                                this.errorCallBack(params.timestamp)
                                                            })
                                                    }
                                                })
                                                .catch((err) => {
                                                    this.errorCallBack(params.timestamp)
                                                })
                                        }
                                    })
                                    .catch((err) => {
                                        this.errorCallBack(params.timestamp)
                                    })
                            }
                        })
                        .catch((err) => {
                            this.errorCallBack(params.timestamp)
                        })
                }
            }
        },
        errorCallBack(timestamp) {
            if (this.timestamp == timestamp) {
                this.timestamp == 0
                this.table.data = []
                this.closeTimer()
            }
        },
        getTableTime() {
            return this.tableTime
        },
        getColumnItem(appname, type) {
            let num = type ? '1' : ''
            return {
                key: 'other_main',
                align: 'center',
                title: appname,
                children: [
                    {
                        key: 'other',
                        align: 'center',
                        children: [
                            {
                                key: 'sub_user_num',
                                minWidth: 80,
                                align: 'center',
                                renderHeader: (h) => this.renderHeader(h, this.getTableTime(), '筛选时间内，盘口该子游戏的投注人数'),
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'sub_user_num', false)
                                    return h('span', { style: { color: result.color, fontWeight: result.fontWeight } }, result.val)
                                }
                            },
                            {
                                key: `sub_user_num_offset`,
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'sub_user_num', true)
                                    return h('span', { style: { color: result.color, fontWeight: result.fontWeight } }, result.val)
                                },
                                renderHeader: (h) => this.renderHeader(h, '当天 - 昨日', '显示盘口该子游戏的投注人数当日-昨日差')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '投注人数', '显示盘口该子游戏的投注人数')
                    },
                    {
                        key: 'bet_point',
                        minWidth: 80,
                        align: 'center',
                        children: [
                            {
                                key: 'bet_point',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'bet_point', false)
                                    return h('span', { style: { color: result.color, fontWeight: result.fontWeight } }, result.val == '-' ? result.val : this.getCustomFixed(result.val / 100000000))
                                },
                                renderHeader: (h) => this.renderHeader(h, this.getTableTime(), '筛选时间内，盘口该子游戏的投注金额')
                            },
                            {
                                key: 'bet_point_offset',
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'bet_point', true)
                                    return h('span', { style: { color: result.color, fontWeight: result.fontWeight } }, result.val == '-' ? '-' : this.getCustomFixed(result.val / 100000000))
                                },
                                renderHeader: (h) => this.renderHeader(h, '当天-昨日', '显示盘口该子游戏的投注金额当天-昨天差')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '投注金额（万）', '显示盘口该子游戏的投注金额')
                    },
                    {
                        key: 'bet_back_rate',
                        minWidth: 80,
                        align: 'center',
                        children: [
                            {
                                key: `loss_rate${num}`,
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'loss_rate', false)
                                    return h('span', { style: { color: result.color, fontWeight: result.fontWeight } }, result.val === '-' ? '-' : (result.val * 100 || 0).toFixed(2) + '%')
                                },
                                renderHeader: (h) => this.renderHeader(h, this.getTableTime(), '（投注金额 - 返奖金额） / 投注金额')
                            },
                            {
                                key: `loss_rate_offset${num}`,
                                minWidth: 80,
                                align: 'center',
                                render: (h, params) => {
                                    let result = this.getOffsetStyle(params.row, type, 'loss_rate', true)
                                    return h('span', { style: { fontWeight: result.fontWeight } }, result.val === '-' ? '-' : (result.val * 100 || 0).toFixed(2) + '%')
                                },
                                renderHeader: (h) => this.renderHeader(h, '当天-昨日', '显示盘口该子游戏的盈利率当天-昨天差')
                            }
                        ],
                        renderHeader: (h) => this.renderHeader(h, '游戏盈利率', '（投注金额 - 返奖金额） / 投注金额')
                    }
                ]
            }
        },
        getColumn(item) {
            let from = [
                {
                    title: '子游戏',
                    key: 'game_name',
                    width: 110,
                    align: 'center',
                    render: (h, params) => {
                        let fontWeight = params.row.game_id == -10 ? 'bold' : ''
                        return h('span', { style: { fontWeight } }, params.row.game_name)
                    }
                },
                this.getColumnItem(item.app_name, 0)
            ]
            if (item.app_name1) {
                from.push(this.getColumnItem(item.app_name1, 1))
            }
            return from
        },
        getAllData(bet_point, loss_point, app_id) {
            return {
                game_id: -10,
                app_id,
                game_name: '合计',
                bet_point,
                sub_user_num: 0,
                loss_point,
                loss_rate: this.calcRate(loss_point, bet_point)
            }
        },
        //透传接口请求参数 请求方法 请求参数
        getTransTopParams(func, param) {
            return {
                mod: 'root',
                platid: param.platid,
                app_id: param.app_id,
                timestamp: param.timestamp,
                app_name: param.app_name,
                platname: param.platname,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param: { ...param }
                }
            }
        },
        handToExe() {
            let date = this.tableTime.replace(/\//gi, '-')
            let str = '盘口,日期,子游戏ID,子游戏名称,游戏人次,子游戏投注人数,赢家数占比,人均每次投注金额,人均游戏次数,转入投注人数,投注用户数占比,投注金额,人均投注金额,返奖金额,游戏盈亏,游戏税收\n'
            this.table.data.forEach((item, index) => {
                item.data.forEach((el, count) => {
                    if (el.game_id > 0) {
                        let last = index == this.table.data.length - 1 && count == item.data.length - 1 ? '' : '\n'
                        str += `${item.app_name},${date},${el.game_id},${el.game_name},${el.round_num},${el.sub_user_num},${(el.winner_rate * 100).toFixed(2) + '%'},${(el.bet_rate / 10000).toFixed(2)},${parseFloat(el.play_rate.toFixed(5))},${el.pay_bet_num},${(el.bet_user_rate * 100).toFixed(2) + '%'},${(el.bet_point / 10000).toFixed(2)},${(el.user_bet_rate / 10000).toFixed(2)},${(el.back_point / 10000).toFixed(2)},${(el.loss_point / 10000).toFixed(2)},${(el.percent_point / 10000).toFixed(2)},${last}`
                    }
                })
            })
            this.noTableCsvToXlsx(str, `子游戏数据 ${date}`)
        },
        getOffsetStyle(row, type, key, isOffset) {
            let from = !type ? row : row.nextType || {}
            let fontWeight = row.game_id == -10 ? 'bold' : ''
            let offset = isOffset ? '_offset' : ''
            let val = from[key] == undefined ? '-' : from[key + offset] || 0
            let color = this.getCompColor(val, true)
            return { fontWeight, val, color }
        },
        getOffsetAndColor(today, type) {
            let game_id = today.game_id
            let yData = this.table.yData[today.app_id] || {}
            let yItem = yData[game_id]
            let offset = 0
            if (yItem) {
                offset = yItem[type]
            }
            let result = today[type] - offset
            return result
            // let color = this.getCompColor(result, type == "loss_rate");
            // return { result, color };
        },
        getCompColor(val, showGreen) {
            return val < 0 ? 'red' : ''
        },
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        }
    }
}
</script>

<style scoped lang="less">
/deep/ .ivu-table .is-green {
    background-color: #32cd32;
}
/deep/ .ivu-table .is-red {
    color: rgb(250, 50, 50);
    // color: #fff;
}
</style>
